import React, { useState, useEffect } from 'react';
import LoginForm from './Pages/LoginForm.jsx';
import Dashboard from './Pages/Dashboard.jsx';
import './App.css';

function App() {
  const [session, setSession] = useState(null);

  // Restore session on app load
  useEffect(() => {
    const token = localStorage.getItem('token');
    const user = localStorage.getItem('user');

    if (token && user) {
      try {
        const parsedUser = JSON.parse(user);
        setSession({ token, user: parsedUser });
      } catch (error) {
        console.error('Failed to parse user from localStorage:', error);
        localStorage.removeItem('user');
        localStorage.removeItem('token');
      }
    }
  }, []);

  const handleLogin = (loginData) => {
    setSession(loginData);
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setSession(null);
  };

  return (
    <div className="App">
      {!session ? (
        <LoginForm onLogin={handleLogin} />
      ) : (
        <Dashboard user={session.user} onLogout={handleLogout} />
      )}
    </div>
  );
}

export default App;